import React from 'react';
import PropTypes from 'prop-types';
import { Section } from '@meronex/components';
import { useHistory, Link } from 'react-router-dom';
import { App } from '@meronex/app';
const meronex = require('./meronex.png');

export default function Home() {
  const history = useHistory();

  return (
    <div style={{ marginTop: '10px', fontFamily: 'Airbnb Cereal App Light' }}>
      <div
        style={{ textAlign: 'center', marginTop: '20vh', cursor: 'pointer' }}>
        <img
          src={meronex}
          style={{
            top: '12px',
            position: 'relative',
            marginLeft: '4px',
            marginRight: '4px',
            width: '200px',
          }}
        />
        <div
          onClick={() => {
            window.open('https://meronex.com');
          }}
          style={{
            cursor: 'pointer',
            textAlign: 'center',
            color: 'gray',
            marginTop: '20px',
            fontSize: '16px',
          }}>
          Everything connects.
        </div>
        <div
          style={{
            marginTop: '60px',
            marginLeft: '20px',
            marginRight: '20px',
          }}>
          <Section>
            <Section.Item>
              <Link to={`/poems`}>
                <div
                  style={{
                    cursor: 'pointer',
                    border: '1px solid rgb(245 119 69 / 52%)',
                    borderRadius: '10px',
                    padding: '10px',
                  }}>
                  <div>
                    <img
                      style={{
                        width: '100px',
                      }}
                      src={`${process.env.PUBLIC_URL}/domains/poems/logo.png`}
                    />
                  </div>
                  <div
                    style={{
                      color: '#848484',
                    }}>
                    5 Poems
                  </div>
                </div>
              </Link>
            </Section.Item>
          </Section>
        </div>
        <div
          style={{
            position: 'fixed',
            bottom: '30px',
            color: 'gray',
            fontSize: '12px',
            width: '100%',
            textAlign: 'center',
          }}>
          <div>{window.location.href}</div>
          <div>
            {' '}
            V{App.metadata.version}-{App.metadata.build}
          </div>
        </div>
      </div>
    </div>
  );
}
